import { render, staticRenderFns } from "./UsageStats.vue?vue&type=template&id=7f70bf05&scoped=true&"
import script from "./UsageStats.vue?vue&type=script&lang=js&"
export * from "./UsageStats.vue?vue&type=script&lang=js&"
import style0 from "./UsageStats.vue?vue&type=style&index=0&id=7f70bf05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f70bf05",
  null
  
)

export default component.exports